import { Component, Input, Output, EventEmitter } from '@angular/core';
import { C3Service, ug } from '@usimweb/ceetron';

//import { SourceEnum, ResultEnum } from '../../../../core/enums/viewer';

// import { Store } from '@ngrx/store';
// import * as fromStore from '../../../core/store';
// import { Results, Result } from '../../../core/models/viewer.interface';

export enum ResultEnum {
  VECTOR = 'vector',
  SCALAR = 'scalar',
}

export enum SourceEnum {
  SOURCE = 'source',
  TARGET = 'target',
}

@Component({
  selector: 'usimweb-results-menu',
  templateUrl: './results-menu.component.html',
  styleUrls: ['./results-menu.component.scss'],
  standalone: false,
})
export class ResultsMenuComponent {
  @Input() scalarResults!: ReadonlyArray<ug.ResultInfo>;

  @Input() modelId!: string;

  @Input() source!: string;

  @Input() type!: string;

  @Output() selectedScaler: EventEmitter<any> = new EventEmitter<any>();

  @Output() selectedVector: EventEmitter<any> = new EventEmitter<any>();

  public defaultResult: number = -1;

  constructor(private c3Service: C3Service) {}

  ngOnInit(): void {
    if (this.c3Service.setDefaultResult) {
      this.setDefaultResults();
    } else {
      this.setSelectedResults();
    }
  }

  private setDefaultResults() {
    if (this.source === SourceEnum.SOURCE && this.type === ResultEnum.VECTOR) {
      this.defaultResult = this.findId('fiberorientation_1');
    }
    if (this.source === SourceEnum.SOURCE && this.type === ResultEnum.SCALAR) {
      this.defaultResult = this.findId('X fiberorientation_1');
    }

    if (this.source === SourceEnum.TARGET && this.type === ResultEnum.SCALAR) {
      this.defaultResult = this.findId('matcherror');
    }
  }

  private setSelectedResults() {
    if (this.source === SourceEnum.SOURCE && this.type === ResultEnum.VECTOR) {
      this.defaultResult = this.getVectorResults();
    }
    if (this.source === SourceEnum.SOURCE && this.type === ResultEnum.SCALAR) {
      this.defaultResult = this.getScalarResults();
    }
    if (this.source === SourceEnum.TARGET && this.type === ResultEnum.VECTOR) {
      this.defaultResult = this.getVectorResults();
    }
    if (this.source === SourceEnum.TARGET && this.type === ResultEnum.SCALAR) {
      this.defaultResult = this.getScalarResults();
    }
  }

  private findId(name: string) {
    if (this.scalarResults.length > 0) {
      const result = this.scalarResults.find((x) => x.name === name);
      return result ? result.id : 0;
    }
    return 0;
  }

  public selectedResult(id: number) {
    if (this.type.includes('scalar')) {
      this.c3Service.setScalarResult(this.modelId, id);
      const scaler = this.scalarResults.filter((x) => x.id === id)[0].name;
      this.selectedScaler.emit({ scaler: scaler, modelId: this.modelId });
    }
    if (this.type.includes('vector')) {
      this.c3Service.setVectorResult(this.modelId, id);
      const vector = this.scalarResults.filter((x) => x.id === id)[0].name;
      this.selectedVector.emit({ vector: vector, modelId: this.modelId });
    }
  }

  public getScalarResults() {
    return this.c3Service.getScalarResult(this.modelId);
  }

  public getVectorResults() {
    return this.c3Service.getVectorResult(this.modelId);
  }
}
